<template>
  <v-layout
    row
    wrap
    grid-list-md
  >
    <v-flex
      xs12
      md6
    >
      <v-card :to="{ name: 'targetslist' }">
        <v-card-title
          primary-title
          justify-center
          align-center
          class="headline"
        >
          <v-icon
            class="mr-4"
            size="50"
            :color="targetsForApproval > 0 ? 'error' : 'grey lighten-1'"
          >
            fa-bullseye
          </v-icon>
          {{ $t('message.targets_for_approval', { num: targetsForApproval }) }}
        </v-card-title>
      </v-card>
    </v-flex>
    <v-flex
      xs12
      md6
    >
      <v-card :to="{ name: 'indicatorslist' }">
        <v-card-title
          primary-title
          justify-center
          align-center
          class="headline"
        >
          <v-icon
            class="mr-4"
            size="50"
            :color="indicatorsForApproval > 0 ? 'error' : 'grey lighten-1'"
          >
            fa-chart-line
          </v-icon>
          {{
            $t('message.indicators_for_approval', {
              num: indicatorsForApproval,
            })
          }}
        </v-card-title>
      </v-card>
    </v-flex>
    <v-flex
      xs12
      md6
    >
      <v-card>
        <v-card-title
          primary-title
          justify-center
          align-center
          class="headline"
        >
          <v-icon
            class="mr-4"
            size="50"
            :color="inactiveUsers.length > 0 ? 'error' : 'grey lighten-1'"
          >
            fa-user
          </v-icon>
          {{
            $tc('message.inactive_users', inactiveUsers.length, {
              num: inactiveUsers.length,
            })
          }}
        </v-card-title>
        <v-card-text v-if="inactiveUsers.length">
          <ul>
            <li
              v-for="item in inactiveUsers"
              :key="item._id"
              class="list-item"
            >
              <span
                style="font-weight: bold;"
              >{{ item.first_name }} {{ item.insertion }}
                {{ item.last_name }}</span>
              <span>{{ item.email }}</span>
            </li>
          </ul>
        </v-card-text>
        <v-card-actions v-if="inactiveUsers.length">
          <v-spacer /><v-btn :to="{ name: 'users' }">
            {{ $t('message.go_to_user_list') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import feathersClient from '../../feathers-client'
export default {
  name: 'AdminDashboard',
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState(['indicatorsForApproval', 'targetsForApproval']),
  },
  data() {
    return {
      inactiveUsers: [],
    }
  },
  created() {
    this.getInactiveUsers()
  },
  methods: {
    getInactiveUsers() {
      feathersClient
        .service('users')
        .find({
          query: {
            active: false,
          },
        })
        .then((res) => {
          this.inactiveUsers = res.data
        })
    },
  },
}
</script>

<style scoped>
.v-card__title {
  flex-wrap: nowrap;
}
a.v-card.v-sheet {
  height: 100%;
}
ul {
  margin-left: 0;
  padding-left: 0;
}
.list-item {
  list-style: none;
  margin-left: 0;
  padding-left: 0;
}
.list-item span {
  font-size: 1.2rem;
  display: inline-block;
  margin-right: 10px;
}
</style>
